import { render, staticRenderFns } from "./aws-ses-send-email.vue?vue&type=template&id=e3170492&scoped=true"
import script from "./aws-ses-send-email.vue?vue&type=script&lang=js"
export * from "./aws-ses-send-email.vue?vue&type=script&lang=js"
import style0 from "./aws-ses-send-email.vue?vue&type=style&index=0&id=e3170492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3170492",
  null
  
)

export default component.exports